export default {
  width: 22,
  height: 17,
  svg: `
  <path d="M3.77592 7.8462L3.43182 7.51978L3.08771 7.8462L1.65589 9.20441L1.27348 9.56716L1.65589 9.92992L7.38317 15.3628L7.72727 15.6892L8.07138 15.3628L20.3441 3.72096L20.7265 3.35821L20.3441 2.99545L18.9123 1.63725L18.5682 1.31083L18.2241 1.63725L7.72727 11.5944L3.77592 7.8462Z"/>
`
}
